import {createSelector} from 'reselect';

const getUnshippableGroups = state => state.deliveryOption.unshippableGroups;

export const makeGetUnshippableItemsByReason = reason => createSelector(
  [getUnshippableGroups],
  unshippableGroups => (reason && reason !== 'unshippableItems' ? unshippableGroups.find(
    group => group.unshippableReason.toLowerCase() === reason.toLowerCase(),
  ) : {}),
);

export default makeGetUnshippableItemsByReason;
